import { useSelector } from "react-redux";

export const useOHData = () => useSelector(({ open_houses }) => open_houses);
